module.exports = __webpack_public_path__ + "static/media/Resume.a22cd491.pdf";